import { SiteRoutes, matchSiteRoute } from '@/views/site/siteRoutes'

type HelpLang = 'en' | 'fr'

interface LocalizedUrl {
    en: string
    fr: string
}

/**
 * Root of the AGRID help center (Notion). Used as a fallback when the current
 * page has no dedicated article. These are the two database views the help
 * button has always pointed to.
 */
export const HELP_CENTER_ROOT: LocalizedUrl = {
    fr: 'https://iodized-fisherman-e9c.notion.site/b926da99ecb34a9f8d116ef3ac0e1a97?v=d351f507b4384357b3b8104e0a99d587&pvs=4',
    en: 'https://iodized-fisherman-e9c.notion.site/215e7a2bcfa3808097b5f40b0af6d27a?v=215e7a2bcfa381a3bcdb000ce21756c5&source=copy_link',
}

/**
 * Page-specific help articles, keyed by the active site route. Add an entry here
 * to point the Help button at a dedicated article for that page.
 */
const SITE_ROUTE_HELP: Partial<Record<SiteRoutes, LocalizedUrl>> = {
    // "Pilotage" page -> Order a command from the dashboard interface
    [SiteRoutes.REALTIME]: {
        en: 'https://iodized-fisherman-e9c.notion.site/Order-a-command-from-the-dashboard-interface-215e7a2bcfa381879134cdae59d7f850',
        fr: 'https://iodized-fisherman-e9c.notion.site/Passer-une-consigne-depuis-l-interface-12ae7a2bcfa38039848adb7628d0113e',
    },
    // "Configuration" page -> Set or adjust temperature limits
    [SiteRoutes.CONSTRAINTS]: {
        en: 'https://iodized-fisherman-e9c.notion.site/Set-or-adjust-temperature-limits-215e7a2bcfa3814bbc86ea04d7de3ff3',
        fr: 'https://iodized-fisherman-e9c.notion.site/Configurer-ou-modifier-les-bornes-de-temp-ratures-2244d2b66b53466db3ddb735bbd05827',
    },
}

/**
 * Returns the most relevant help-center URL for the current location.
 * Falls back to the help-center root when the current page has no dedicated article.
 */
export function getHelpUrl(pathname: string, language?: string): string {
    const lang: HelpLang = language === 'en' ? 'en' : 'fr'
    const siteRoute = matchSiteRoute(pathname)
    const pageHelp = siteRoute ? SITE_ROUTE_HELP[siteRoute] : undefined
    return (pageHelp ?? HELP_CENTER_ROOT)[lang]
}
